import { useEffect, useRef } from 'react'

export function useInterval(callback: () => void, delay: number | undefined) {
	const intervalRef = useRef<undefined | number>(null)
	const savedCallback = useRef(callback)

	useEffect(() => {
		savedCallback.current = callback
	}, [callback])

	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	useEffect(() => {
		const tick = () => {
			savedCallback.current()
		}

		if (typeof delay === 'number') {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			intervalRef.current = window.setInterval(tick, delay)

			return () => {
				window.clearInterval(intervalRef.current!)
			}
		}
	}, [delay])

	return intervalRef
}
